import React from 'react';
import GlobalTypography from '../canvas/GlobalStyle/GlobalTypography';
import {
	Popover,
	Button,
	Text,
	PopoverContent,
	useDisclosure,
	Box,
	PopoverHeader,
	Flex,
	FormLabel,
	PopoverCloseButton,
	PopoverTrigger,
	Portal,
	IconButton,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { customFonts } from '../../redux/customFontsSlice';
import { UilFont } from '@iconscout/react-unicons';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };
const boxW = '430px';
const boxPopoverWrapper = {
	transition: 'none',
	borderRadius: '6px',
	boxShadow: 'xl',
	zIndex: 9999,
	bg: 'white',
	w: boxW,
	top: 0,
};

const PopoverEditGlobalTypography = ({ viewId }) => {
	// const { onOpen, onClose, isOpen } = useDisclosure();
	const fonts = useSelector(customFonts);
	const editorRef = React.useRef(null);

	return (
		<Popover zIndex={9999} placement="right-end" w={'auto'} ml={'20px'}>
			<PopoverTrigger>
				<IconButton
					disabled={fonts?.length ? false : true}
					bg={'white'}
					_hover={y300}
					_active={y400}
					_focus={y400}
					variant="outline"
					aria-label="Editor de Fontes"
					icon={<UilFont size={24} />}
				/>
			</PopoverTrigger>
			<Portal>
				<PopoverContent w={boxW} ml={'20px'}>
					<Box ref={editorRef} {...boxPopoverWrapper}>
						<PopoverHeader _hover={{ cursor: 'grab' }} bg={'gray.100'} borderRadius={'6px 6px 0 0'}>
							<Flex userSelect={'none'} _hover={{ cursor: 'grab' }} position="relative">
								<FormLabel
									_hover={{ cursor: 'grab' }}
									m={0}
									borderColor={'gray.200'}
									fontFamily={'Poppins'}
									color={'gray.700'}
									fontWeight="bold"
								>
									Editor de Fontes
								</FormLabel>
								<PopoverCloseButton top={0} right={0} />
							</Flex>
						</PopoverHeader>
						<GlobalTypography {...{ fonts, viewId }} />
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};

export default PopoverEditGlobalTypography;
